import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export type QueryProviderProps = {
  children: React.ReactNode;
};

/**
 * QueryProvider
 *
 * Wraps the app with a shared TanStack QueryClient (CSR-only).
 * Defaults are conservative to avoid noisy refetches in the MVP.
 */
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 30_000, // 30s
        gcTime: 5 * 60 * 1000, // 5m
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export function QueryProvider({ children }: QueryProviderProps) {
  const [client] = React.useState(() => createQueryClient());

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
